module.exports = __webpack_public_path__ + "static/media/fr.2f09e1e4.svg";